import { AxDropdown } from "@axess/limestone";
import { AxCheck } from "../../../Components/AxForm/AxCheck";
import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { addUniqueObjectToArray } from "../../../Lib/Helper/ObjectHelper";
import { PriceHelper } from "../../../Lib/Helper/PriceHelper";
import { CompPackOrderRentalValues } from "../../../Models/ComplexPackages/BookingOptions/CompPackOrderRentalValues";
import { CultureInfo } from "../../../Models/Culture/CultureInfo";
import { RentalItem } from "../../../Models/Rental/RentalItem";
import { ComplexPackageBookingOptions } from "../ComplexPackageBookingOptions";

@ModuleName("CompPackBookingRentalOptions")
export class CompPackBookingRentalOptions implements AxInit {
    private $parent: JQuery<HTMLElement> = $('[data-frontoffice-view="complexpackagesbooking"]');
    private priceAfterDiscounts: number;
    private rentalItems: RentalItem[];
    private cpBookingOptions: ComplexPackageBookingOptions = AxLoad.GetModule<ComplexPackageBookingOptions>("ComplexPackageBookingOptions");
    private pickUpLocationDropdown: AxDropdown = new AxDropdown();
    private checkBoxesAdditionalRentalItems: AxCheck[] = [];
    private priceHelper: PriceHelper;

    AxInit(init: ICompPackBookingRentalOptionsInitData): void {
        this.priceAfterDiscounts = init.priceAfterDiscounts;
        this.priceHelper = new PriceHelper(init.cultureInfo, false);

        // not used currently but needed in the future
        //this.setUpPickupLocationDropdown();
        this.rentalItems = JSON.parse((init?.rentalItems || []).toString());

        this.addRentalValues();

        this.initCheckBoxesAdditionalItems();
    }

    // addRentalValues
    addRentalValues() {
        for (let rentalItem of this.rentalItems) {
            if (!rentalItem.isOptional) {
                const rentalValues = new CompPackOrderRentalValues(rentalItem.rentalItemNr, rentalItem.rentalPersTypeNr, rentalItem.packagePositionNr);
                this.cpBookingOptions.bookingValuesList.forEach((bookingValues) => {
                    bookingValues.rentalOrderValues.push(rentalValues);
                });
            }
        }
    }

    initCheckBoxesAdditionalItems() {
        this.$parent
            .find('[data-rental-optional]').first()
            .find('.compPack_additionalRental_item_check')
            .each((_, el) => {
                let id = $(el).attr('data-rentalItem-id');
                this.checkBoxesAdditionalRentalItems.push(new AxCheck(`identifierAdditionalRentalCheckbox_${id}`, el));
            });

        this.$parent.on('change', '.compPack_additionalRental_item_check', () => this.checkAdditionalItemsChecked());

        this.cpBookingOptions.bookingValuesList.forEach((bookingValues) => {
            bookingValues.additionalRentalOrderValues = new Array<CompPackOrderRentalValues>();
        });

        // initial check
        this.checkAdditionalItemsChecked();
    }

    checkAdditionalItemsChecked() {
        let additionalPrice = 0;
        let additionalItemsSelected = 0;

        this.$parent.find('.compPack_additionalRental_item_check').each((i, el) => {
            const isChecked = $(el).is(':checked');
            const isPreselected : boolean = $(el).attr('data-rental-preselected') === 'true';
            const participant: number = Number($(el).attr('data-participant') || 1);
            const index = participant - 1;
            const rentalItemId: number = Number($(el).attr('data-rentalItem-id') || 0);
            const personType: number = Number($(el).attr('data-rental-personType') || 0);
            const packagePositionNr: number = Number($(el).attr('data-rental-packagePositionNr') || 0);

            const $additionalRentalItem = $(`#additionalRentalItem_${rentalItemId}_${personType}_${packagePositionNr}`);
            const $additionalRentalItemsDivider = this.$parent.find('#additionalRentalItemsDivider');
            const rentalItemPrice: number = Number($($additionalRentalItem).attr('data-rentalItem-price'));
            const bookingvalue = this.cpBookingOptions.bookingValuesList[index];
            if (isChecked && i === index) {
                const additionalRentalOrderValues = new CompPackOrderRentalValues(rentalItemId, personType, packagePositionNr);
                !bookingvalue.additionalRentalOrderValues.some((o) => o.rentalItemNr === rentalItemId)
                    && (bookingvalue.additionalRentalOrderValues = [
                        ...bookingvalue.additionalRentalOrderValues,
                        additionalRentalOrderValues,
                    ]);

                $($additionalRentalItem).removeClass('d-none').addClass('d-flex');

                additionalPrice += rentalItemPrice;
                additionalItemsSelected++;
            } else if (!isChecked && i === index) {
                const additionalRentalOrderValues = bookingvalue.additionalRentalOrderValues.filter((order) => (
                    order.rentalItemNr != rentalItemId
                ));
                bookingvalue.additionalRentalOrderValues = additionalRentalOrderValues;
            }

            const price = this.priceHelper.GetPrice(additionalPrice);
            const priceWithSymbol = this.priceHelper.GetPriceStringWithCurrencySymbol(price);
            $additionalRentalItem.children('div:last-child').html(priceWithSymbol);

            if (additionalItemsSelected > 0) {
                $additionalRentalItemsDivider.removeClass('d-none');
            } else {
                $additionalRentalItem.removeClass('d-flex').addClass('d-none');
                $additionalRentalItemsDivider.addClass('d-none');
            }
        });

        const newPrice = this.priceHelper.GetPrice(additionalPrice + this.priceAfterDiscounts);
        $('#compPackBookingPriceSum').html(this.priceHelper.GetPriceStringWithCurrencySymbol(newPrice));
    }

    setUpPickupLocationDropdown() {
        this.pickUpLocationDropdown.init('.prod_selection__pickup-selection .ax-form-select');
        this.cpBookingOptions.dropDowns = addUniqueObjectToArray(this.cpBookingOptions.dropDowns, this.pickUpLocationDropdown, this.pickUpLocationDropdown.getSelector);

        // Pickup
        $('.prod_selection__pickup-selection').on('click', (x) => {
            $('.compPack_bookingOption_pickup_select').toggleClass('active');
        });

        $('.compPack_bookingOption_rentalLocation_option').on('click', (x) => {
            let locationId = $(x.target).attr('data-value');
            this.cpBookingOptions.bookingValuesList.forEach((bookingValues) => {
                bookingValues.pickupLocationId = Number(locationId);
            });
            $('.compPack_bookingOption_pickup_select').removeClass('active');
        });
    }
}

interface ICompPackBookingRentalOptionsInitData {
    rentalItems: RentalItem[];
    cultureInfo: CultureInfo;
    priceAfterDiscounts: number;
}
